import { render, staticRenderFns } from "./users-overview.vue?vue&type=template&id=59891d4c&"
import script from "./users-overview.vue?vue&type=script&lang=js&"
export * from "./users-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports